<script>
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: 'Approval Settings',
			items: [
				{
					text: 'approval-settings',
					href: '/',
				},
			],
			userData: JSON.parse(localStorage.getItem('web_user')),
			users: [],
			roles: [],
			locations: [],
			isUpdatingTaskAssignment: false,
			selectedLocation: 2, // Minneapolis
			selectedApplicationType: 3,
			setAssignmentForm: {
				taskName: null,
				taskKey: null,
				locationId: null,
				userTypeId: null,
				assignmentRole: null,
				assignmentType: null,
				assignmentUsers: [],
			},
			dynamicallyAssignableTasks: {
				inState: {
					mentor: ['send_meeting_invite_applicant', 'confirm_meeting_date', 'review_application_waitlist', 'screening_meeting_complete', 'introduce_applicant_to_client', 'confirm__roi_release_info_signature'],
					volunteer: ['feedback_on_assignment', 'schedule_first_assignment', 'confirm_onboarding_complete', 'confirm_assignment_date_role'],
				},
				outState: {
					mentor: ['send_calendar_invite', 'review_application_waitlist', 'screening_meeting_complete', 'orientation', 'confirm__roi_release_info_signature', 'document_introduction_date_client'],
					volunteer: ['schedule_first_assignment'],
				},
			},
			settings: [],
			volunteerInStateTasksSequence: [
				{
					label: 'Review Application',
					key: 'review_application',
				},
				{
					label: 'Confirm Application Status',
					key: 'confirm_application_status',
				},
				{
					label: 'Screening Meeting (Phone Call)',
					key: 'request_intro_meeting',
				},
				{
					label: 'Send DHS & Orientation email',
					key: 'send_dhs_orientation_email',
				},
				{
					label: 'State ID, Authorization Form, Date of Orientation Received',
					key: 'state_id_authorization',
				},
				{
					label: 'Send Fingerprinting instructions email',
					key: 'send_fingerprinting_instructions_email',
				},
				{
					label: 'Start DHS Background Check',
					key: 'start_dhs_background_check',
				},
				{
					label: 'Check Fingerprinting Status',
					key: 'check_fingerprinting_status',
				},
				{
					label: 'Confirm Fingerprinting with Applicant',
					key: 'confirm_fingerprinting_with_applicant',
				},
				{
					label: 'Follow-up on Check Fingerprinting Status',
					key: 'follow_up_on_check_fingerprinting_status',
				},
				{
					label: 'Confirm DHS Status',
					key: 'confirm_dhs_status',
				},
				{
					label: 'Upload DHS determination letter to R Drive',
					key: 'upload_letter_r_drive',
				},
				{
					label: 'Document Case Details',
					key: 'document_case_details',
				},
				{
					label: 'Send Calendar Invite',
					key: 'send_calendar_invite',
				},
				{
					label: 'Send Orientation confirmation email',
					key: 'send_orientation_confirmation_email',
				},
				{
					label: 'Orientation Completed',
					key: 'orienation_confirmed',
				},
				{
					label: 'Application Approved',
					key: 'application_approved',
				},
				{
					label: 'Assign Applicant',
					key: 'assign_applicant',
				},
				{
					label: 'Send Assignment Email',
					key: 'send_assignment_email',
				},
				{
					label: 'Feedback on Assignment',
					key: 'feedback_on_assignment',
				},
				{
					label: 'Schedule first Assignment',
					key: 'schedule_first_assignment',
				},
				{
					label: 'Confirm Onboarding Complete',
					key: 'confirm_onboarding_complete',
				},
				{
					label: 'Confirm Assignment Date/Role',
					key: 'confirm_assignment_date_role',
				},
			],
			volunteerOutStateTasksSequence: [
				{
					label: 'Review Application',
					key: 'review_application',
				},
				{
					label: 'Confirm Application Status',
					key: 'confirm_application_status',
				},
				{
					label: 'Send Application Response and DHS email',
					key: 'send_dhs_orientation_email',
				},
				{
					label: 'State ID, Authorization Form, Date of Orientation Received',
					key: 'state_id_authorization',
				},
				{
					label: 'Send Fingerprinting instructions email',
					key: 'send_fingerprinting_instructions_email',
				},
				{
					label: 'Start DHS Background Check',
					key: 'start_dhs_background_check',
				},
				{
					label: 'Check Fingerprinting Status',
					key: 'check_fingerprinting_status',
				},
				{
					label: 'Confirm Fingerprinting with Applicant',
					key: 'confirm_fingerprinting_with_applicant',
				},
				{
					label: 'Follow-up on Check Fingerprinting Status',
					key: 'follow_up_on_check_fingerprinting_status',
				},
				{
					label: 'Confirm DHS Status',
					key: 'confirm_dhs_status',
				},
				{
					label: 'Upload DHS determination letter to R Drive',
					key: 'upload_letter_r_drive',
				},
				{
					label: 'Document Case Details',
					key: 'document_case_details',
				},
				{
					label: 'Screening Meeting (Phone Call)',
					key: 'request_intro_meeting',
				},
				{
					label: 'Orientation / Intro Meeting Complete',
					key: 'orientation',
				},
				{
					label: 'Confirm Assignment Date/Role',
					key: 'confirm_assignment_date_role',
				},
				{
					label: 'Schedule first Assignment',
					key: 'schedule_first_assignment',
				},
			],
			mentorInStateTasksSequence: [
				{
					label: 'Review Application',
					key: 'review_application',
				},
				{
					label: 'Confirm Application Status',
					key: 'confirm_application_status',
				},
				{
					label: 'Start Intellicorps Background Check',
					key: 'start_sterling_background_check',
				},
				{
					label: 'Send Application Received Email',
					key: 'send_appilcation_received_email',
				},
				{
					label: 'Confirm Intellicorps Background Status',
					key: 'confirm_sterling_background_status',
				},
				{
					label: 'Remove SS and DL',
					key: 'remove_ss_and_dL',
				},
				{
					label: 'Follow Up with Character Reference',
					key: 'follow_up_character_reference',
				},
				{
					label: 'Received Character Reference',
					key: 'received_character_reference',
				},
				{
					label: 'Review Character References',
					key: 'review_character_references',
				},
				{
					label: 'Character Reference Confirmed',
					key: 'character_reference_confirmed',
				},
				{
					label: 'Send DHS email',
					key: 'send_dhs_orientation_email',
				},
				{
					label: 'State ID, Authorization Form, Date of Orientation Received',
					key: 'state_id_authorization',
				},
				{
					label: 'Send Orientation confirmation email',
					key: 'send_orientation_confirmation_email',
				},
				{
					label: 'Send Calendar Invite',
					key: 'send_calendar_invite',
				},
				{
					label: 'Send Fingerprinting instructions email',
					key: 'send_fingerprinting_instructions_email',
				},
				{
					label: 'Start DHS Background Check (NetStudy 2.0)',
					key: 'start_dhs_background_check',
				},
				{
					label: 'Check Fingerprinting Status',
					key: 'check_fingerprinting_status',
				},
				{
					label: 'Confirm Fingerprinting with Applicant',
					key: 'confirm_fingerprinting_with_applicant',
				},
				{
					label: 'Follow-up on Check Fingerprinting Status',
					key: 'follow_up_on_check_fingerprinting_status',
				},
				{
					label: 'Confirm DHS Status',
					key: 'confirm_dhs_status',
				},
				{
					label: 'Upload DHS determination letter to R Drive',
					key: 'upload_letter_r_drive',
				},
				{
					label: 'Document Case Details',
					key: 'document_case_details',
				},
				{
					label: 'Orientation Completed',
					key: 'orienation_confirmed',
				},
				{
					label: 'Application Approved',
					key: 'application_approved',
				},
				{
					label: 'Assign Applicant',
					key: 'assign_applicant',
				},
				{
					label: 'Email Applicant Background Information to CCM',
					key: 'email_applicant_background_info_to_ccm',
				},
				{
					label: 'Send assignment email to mentor/CCM',
					key: 'send_assignment_email_to_mentor_ccm',
				},
				{
					label: 'Send Meeting Invite Email to Applicant',
					key: 'send_meeting_invite_applicant',
				},
				{
					label: 'Confirm Meeting Date',
					key: 'confirm_meeting_date',
				},
				{
					label: 'Review Application / Waitlist',
					key: 'review_application_waitlist',
				},
				{
					label: 'Screening Meeting Complete',
					key: 'screening_meeting_complete',
				},
				{
					label: 'Introduce Applicant to Client',
					key: 'introduce_applicant_to_client',
				},
				{
					label: 'Confirm (ROI) Release of Information Signature',
					key: 'confirm__roi_release_info_signature',
				},
				{
					label: 'Document Introduction Date/Client',
					key: 'document_introduction_date_client',
				},
			],
			mentorOutStateTasksSequence: [
				{
					label: 'Review Application',
					key: 'review_application',
				},
				{
					label: 'Confirm Application Status',
					key: 'confirm_application_status',
				},
				{
					label: 'Start Intellicorps Background Check',
					key: 'start_sterling_background_check',
				},
				{
					label: 'Send Application Received Email',
					key: 'send_appilcation_received_email',
				},
				{
					label: 'Confirm Intellicorps Background Status',
					key: 'confirm_sterling_background_status',
				},
				{
					label: 'Remove SS and DL',
					key: 'remove_ss_and_dL',
				},
				{
					label: 'Follow Up with Character Reference',
					key: 'follow_up_character_reference',
				},
				{
					label: 'Received Character Reference',
					key: 'received_character_reference',
				},
				{
					label: 'Review Character References',
					key: 'review_character_references',
				},
				{
					label: 'Character Reference Confirmed',
					key: 'character_reference_confirmed',
				},
				{
					label: 'Screening Meeting Complete',
					key: 'screening_meeting_complete',
				},
				{
					label: 'Send DHS email',
					key: 'send_dhs_orientation_email',
				},
				{
					label: 'State ID, Authorization Form, Date of Orientation Received',
					key: 'state_id_authorization',
				},
				{
					label: 'Send Fingerprinting instructions email',
					key: 'send_fingerprinting_instructions_email',
				},
				{
					label: 'Start DHS Background Check (NetStudy 2.0)',
					key: 'start_dhs_background_check',
				},
				{
					label: 'Check Fingerprinting Status',
					key: 'check_fingerprinting_status',
				},
				{
					label: 'Confirm Fingerprinting with Applicant',
					key: 'confirm_fingerprinting_with_applicant',
				},
				{
					label: 'Follow-up on Check Fingerprinting Status',
					key: 'follow_up_on_check_fingerprinting_status',
				},
				{
					label: 'Confirm DHS Status',
					key: 'confirm_dhs_status',
				},
				{
					label: 'Upload DHS determination letter to R Drive',
					key: 'upload_letter_r_drive',
				},
				{
					label: 'Document Case Details',
					key: 'document_case_details',
				},
				{
					label: 'Application Approved',
					key: 'application_approved',
				},
				{
					label: 'Assign Applicant',
					key: 'assign_applicant',
				},
				{
					label: 'Schedule Orientation / Intro Meeting',
					key: 'send_calendar_invite',
				},
				{
					label: 'Review Application / Waitlist',
					key: 'review_application_waitlist',
				},
				{
					label: 'Orientation / Intro Meeting Complete',
					key: 'orientation',
				},
				{
					label: 'Confirm (ROI) Release of Information Signature',
					key: 'confirm__roi_release_info_signature',
				},
				{
					label: 'Document Introduction Date/Client',
					key: 'document_introduction_date_client',
				},
			],
		};
	},
	mounted() {
		const component = this;
		component.getRoles();
		component.getApprovalSettings();
		component.getLocations();
		component.getAdminUsers();
	},
	methods: {
		async getRoles() {
			try {
				let component = this;
				let token = localStorage.getItem('token');
				if (!token) {
					throw new Error('Invalid login');
				}

				let config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};

				const response = await axios.get('admin/user/types', config);
				if (!response || !response.data || !response.data.response) {
					throw new Error('Received empty or Invalid response from server');
				}

				let roles = response.data.response;
				component.roles = roles;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
			}
		},
		async getApprovalSettings() {
			try {
				let component = this;
				let token = localStorage.getItem('token');
				if (!token) {
					return;
				}

				let config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};

				const response = await axios.get('admin/approvals/settings', config);
				if (!response || !response.data || !response.data.response) {
					throw new Error('Received empty or Invalid response from server');
				}

				let approvalSettings = response.data.response;
				component.settings = approvalSettings;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
			}
		},
		async getAdminUsers() {
			try {
				let component = this;
				const response = await axios.get('admin/users');
				if (!response || !response.data || !response.data.response) {
					throw new Error('Received empty or Invalid response from server');
				}

				const users = response.data.response;
				component.users = users;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
			}
		},
		async getLocations() {
			try {
				let component = this;
				const response = await axios.get('locations?pagination=true&per_page=1000');
				if (!response || !response.data || !response.data.response || !response.data.response.data) {
					throw new Error('Received empty or Invalid response from server');
				}

				const locations = response.data.response.data;
				component.locations = locations;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
			}
		},
		getLocationAssignmentTasks(locationId, userTypeId) {
			try {
				const component = this;
				const MINNEAPOLIS = 2;
				const BUFFALO = 4;

				if (!locationId) {
					throw new Error('Invalid location id provided for task assignment setting');
				}

				if (!userTypeId) {
					throw new Error('Invalid user type id provided for task assignment setting');
				}

				let tasks = [];
				if (MINNEAPOLIS == locationId || BUFFALO == locationId) {
					// Minneapolis & Buffalo
					if (3 == userTypeId) {
						// Mentor
						tasks = component.mentorInStateTasksSequence;
					} else if (4 == userTypeId) {
						// Volunteer
						tasks = component.volunteerInStateTasksSequence;
					}
				} else {
					// Other Locations
					if (3 == userTypeId) {
						// Mentor
						tasks = component.mentorOutStateTasksSequence;
					} else if (4 == userTypeId) {
						// Volunteer
						tasks = component.volunteerOutStateTasksSequence;
					}
				}

				return tasks;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
				return [];
			}
		},
		getSelectableUsers(userTypeId, locationId) {
			try {
				const component = this;

				if (!userTypeId) {
					return [];
				}

				if (!component.users || component.users.length == 0) {
					return [];
				}

				let users = component.users.filter(function (user) {
					let userTypeCondition1 = user.user_type_id == userTypeId;
					let userTypeCondition2 = Array.from(user.UserTypes)
						.map((item) => item['id'])
						.includes(userTypeId);
					let userLocationCondition1 = user.location_id == locationId;
					let userLocationCondition2 = Array.from(user.locations).includes(locationId);
					return (userTypeCondition1 || userTypeCondition2) && (userLocationCondition1 || userLocationCondition2);
				});
				return users;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
				return [];
			}
		},
		setTaskAssignment(task) {
			try {
				const component = this;
				// reset editable fields
				component.setAssignmentForm.assignmentRole = null;
				component.setAssignmentForm.assignmentUsers = [];

				// set default fields
				component.setAssignmentForm.locationId = component.selectedLocation;
				component.setAssignmentForm.userTypeId = component.selectedApplicationType;
				component.setAssignmentForm.taskKey = task.key;
				component.setAssignmentForm.taskName = task.label;

				component.$bvModal.show('assignment-set-modal');
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
			}
		},
		async saveTaskAssignment() {
			try {
				const component = this;
				component.isUpdatingTaskAssignment = true;

				// construct save object
				const taskAssignment = {
					task_name: component.setAssignmentForm.taskName,
					task_key: component.setAssignmentForm.taskKey,
					user_type_id: component.setAssignmentForm.userTypeId,
					role_id: component.setAssignmentForm.assignmentRole,
					user_ids: component.setAssignmentForm.assignmentUsers,
					location_id: component.setAssignmentForm.locationId,
					assignment_type: component.setAssignmentForm.assignmentType,
				};

				// reset fields
				component.setAssignmentForm.assignmentRole = null;
				component.setAssignmentForm.assignmentUsers = [];
				component.setAssignmentForm.locationId = null;
				component.setAssignmentForm.taskKey = null;
				component.setAssignmentForm.taskName = null;
				component.setAssignmentForm.userTypeId = null;
				component.setAssignmentForm.assignmentType = null;

				// api update
				let token = localStorage.getItem('token');
				if (!token) {
					Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});
					component.$bvModal.hide('assignment-set-modal');
					window.location.reload();
					return;
				}

				let config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};

				await axios.post('admin/approvals/settings', taskAssignment, config);
				component.isUpdatingTaskAssignment = false;
				component.$bvModal.hide('assignment-set-modal');
				Swal.fire({
					title: 'Success!',
					text: 'Settings Saved!',
					icon: 'success',
					width: 350,
					showConfirmButton: false,
					timer: 1500,
				});
				component.getApprovalSettings();
			} catch (error) {
				const component = this;
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				component.isUpdatingTaskAssignment = false;
				console.log(error);
			}
		},
		getTaskAssignmentType(taskKey) {
			try {
				const component = this;
				const locationId = component.selectedLocation;
				const userTypeId = component.selectedApplicationType;

				if (!taskKey || !locationId || !userTypeId || component.settings.length == 0 || component.roles.length == 0) {
					return '';
				}

				let assignmentType = '';
				let taskSettings = component.settings.find(function (element) {
					return element.task_key == taskKey && element.location_id == locationId && element.user_type_id == userTypeId;
				});

				if (!taskSettings) {
					return '';
				}

				assignmentType = taskSettings.assignment_type || '';
				return assignmentType;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
				return '';
			}
		},
		getTaskAssignedRole(taskKey) {
			try {
				const component = this;
				const locationId = component.selectedLocation;
				const userTypeId = component.selectedApplicationType;

				if (!taskKey || !locationId || !userTypeId || component.settings.length == 0 || component.roles.length == 0) {
					return '';
				}

				let assignedRole = '';
				let taskSettings = component.settings.find(function (element) {
					return element.task_key == taskKey && element.location_id == locationId && element.user_type_id == userTypeId;
				});

				if (!taskSettings) {
					return '';
				}

				let role = component.roles.find(function (role) {
					return role.id == taskSettings.role_id;
				});

				if (!role) {
					return '';
				}

				assignedRole = role?.type || 'N/A';
				return assignedRole;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
				return [];
			}
		},
		getTaskAssignedUsers(taskKey) {
			try {
				const component = this;
				const locationId = component.selectedLocation;
				const userTypeId = component.selectedApplicationType;

				if (!taskKey || !locationId || !userTypeId || component.settings.length == 0 || component.users.length == 0) {
					return '';
				}

				let taskSettings = component.settings.find(function (element) {
					return element.task_key == taskKey && element.location_id == locationId && element.user_type_id == userTypeId;
				});

				if (!taskSettings) {
					return '';
				}

				let _users = component.users.filter(function (user) {
					return taskSettings.user_ids.includes(user.id.toString());
				});

				if (_users.length == 0) {
					return '';
				}

				let assignedUsers = _users.map((user) => [user.first_name, user.last_name].join(' ')).join(', ');
				return assignedUsers;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
				return '';
			}
		},
		isDynamicallyAssignable(taskKey) {
			try {
				const component = this;
				let isDynamicallyAssignable = false;
				/**
				 * Minneapolis: 2
				 * Buffalo: 4
				 */
				if (component.selectedLocation == 2 || component.selectedLocation == 4) {
					// in-state:
					if (component.selectedApplicationType == 3) {
						// mentor
						isDynamicallyAssignable = component.dynamicallyAssignableTasks.inState.mentor.includes(taskKey);
					} else {
						// volunteer
						isDynamicallyAssignable = component.dynamicallyAssignableTasks.inState.volunteer.includes(taskKey);
					}
				} else {
					// out-state
					if (component.selectedApplicationType == 3) {
						// mentor
						isDynamicallyAssignable = component.dynamicallyAssignableTasks.outState.mentor.includes(taskKey);
					} else {
						// volunteer
						isDynamicallyAssignable = component.dynamicallyAssignableTasks.outState.volunteer.includes(taskKey);
					}
				}

				return isDynamicallyAssignable;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
				return false;
			}
		},
		resetModal() {
			try {
				const component = this;
				component.setAssignmentForm.taskName = null;
				component.setAssignmentForm.taskKey = null;
				component.setAssignmentForm.locationId = null;
				component.setAssignmentForm.userTypeId = null;
				component.setAssignmentForm.assignmentRole = null;
				component.setAssignmentForm.assignmentType = null;
				component.setAssignmentForm.assignmentUsers = [];
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
				return;
			}
		},
	},
	computed: {
		filteredSettings() {
			try {
				let component = this;
				let settings = [];
				if (!component.selectedLocation || !component.selectedApplicationType) {
					return settings;
				}

				settings = component.getLocationAssignmentTasks(component.selectedLocation, component.selectedApplicationType);
				return settings;
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
				return [];
			}
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" />
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-12">
						<div class="row align-items-center form-inline mb-4 border p-3 m-0">
							<div class="col-md-4">
								<label>Location</label>
								<b-form-select class="form-select" :options="locations" value-field="id" text-field="name" @change="(e) => () => console.log(e)" v-model="selectedLocation"></b-form-select>
							</div>

							<div class="col-md-4">
								<label>Application Type</label>
								<div class="form-group">
									<div class="form-check form-check-inline">
										<input class="form-check-input" id="application-type-mentor" type="radio" :value="3" v-model="selectedApplicationType" />
										<label class="form-check-label" for="application-type-mentor">Mentor</label>
									</div>
									<div class="form-check form-check-inline">
										<input class="form-check-input" id="application-type-volunteer" type="radio" :value="4" v-model="selectedApplicationType" />
										<label class="form-check-label" for="application-type-volunteer">Volunteer</label>
									</div>
								</div>
							</div>
						</div>

						<!--  -->
						<div class="table-responsive">
							<table class="table table-bordered table-hover table-striped align-middle mb-0">
								<thead class="table-light">
									<tr>
										<th scope="col">Workflow Task</th>
										<th scope="col">Assigned Role</th>
										<th scope="col">Assigned Users</th>
										<th scope="col">&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(task, index) in filteredSettings" :key="index">
										<td>
											<h5 class="font-size-13 text-truncate mb-1">
												{{ task.label }}
											</h5>
										</td>
										<td>
											<span>{{ getTaskAssignedRole(task.key) }}</span>
										</td>
										<td>
											<span v-if="getTaskAssignmentType(task.key) == 'static'">{{ getTaskAssignedUsers(task.key) }}</span>
											<span v-else>Dynamically Assigned</span>
										</td>
										<td>
											<div class="d-grid">
												<button type="submit" class="btn btn-block btn-primary" @click="() => setTaskAssignment(task)">Set</button>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Role/Users Assignment Modal -->
		<b-modal id="assignment-set-modal" centered title="Assign User Role & Users for this Task" title-class="font-18" @hidden="resetModal" hide-footer>
			<form @submit.prevent="saveTaskAssignment">
				<div class="row mb-3">
					<div class="col">
						<p><strong>Task:</strong> {{ setAssignmentForm.taskName }}</p>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col">
						<label>Assignment Role</label>
						<b-form-select class="form-select" :options="roles" value-field="id" text-field="type" v-model="setAssignmentForm.assignmentRole" required :disabled="isUpdatingTaskAssignment">
							<option slot="first" :value="null" disabled>Select Role</option>
						</b-form-select>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col">
						<label>Assignment Type</label>
						<b-form-select class="form-select" value-field="value" text-field="label" v-model="setAssignmentForm.assignmentType" required :disabled="isUpdatingTaskAssignment">
							<option slot="first" :value="null" disabled>Select Type</option>
							<option value="static">Static</option>
							<option value="dynamic" :disabled="!isDynamicallyAssignable(setAssignmentForm.taskKey)">Dynamic</option>
						</b-form-select>
					</div>
				</div>

				<div class="row mb-3" v-if="setAssignmentForm.assignmentType == 'static'">
					<div class="col">
						<label>Assignment Users</label>
						<b-form-select class="form-select" :options="getSelectableUsers(setAssignmentForm.assignmentRole, selectedLocation)" multiple size="lg" value-field="id" text-field="username" :select-size="5" v-model="setAssignmentForm.assignmentUsers" required :disabled="isUpdatingTaskAssignment">
							<template v-slot:first>
								<option disabled value="">Please select one or more users</option>
							</template>
						</b-form-select>
					</div>
				</div>

				<div class="d-grid">
					<button type="submit" class="btn btn-block btn-primary" :disabled="!setAssignmentForm.assignmentRole || !setAssignmentForm.assignmentType || (setAssignmentForm.assignmentType == 'static' && !setAssignmentForm.assignmentUsers.length) || isUpdatingTaskAssignment">Save</button>
				</div>
			</form>
		</b-modal>
	</Layout>
</template>
